<mat-form-field [appearance]="appearance()" class="w-100 dense-2">
  <mat-label>{{ label() }}</mat-label>
  <input
    matInput
    [placeholder]="placeholder()"
    [formControl]="formControlRef()"
    [type]="showPassword ? 'text' : 'password'"
  />
  <mat-icon matSuffix role="button" (click)="showPassword = !showPassword">
    {{ showPassword ? "visibility" : "visibility_off" }}
  </mat-icon>
  <mat-hint>
    <ng-content select="[slot=hint]"> </ng-content>
  </mat-hint>
</mat-form-field>
